<template>
  <v-layout wrap>
    <v-flex xs2>
      <v-text-field
        label="SKU"
        v-model="sku.name"
        prepend-icon="assignment"
        dark
        required
        disabled
      ></v-text-field>
    </v-flex>
    <v-flex xs1>
      <v-text-field
        label="App Blocks"
        v-model="sku.count"
        required
        :disabled="!isZeroSku"
      ></v-text-field>
    </v-flex>
    <v-flex xs2>
      <v-text-field
        label="Codes Count"
        v-model="countRaw"
        mask="#####"
        :error-messages="countErrors"
        @input="$v.count.$touch()"
        @blur="$v.count.$touch()"
        :disabled="isBusy"
        required
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-text-field
        v-if="this.count"
        label="Name"
        v-model="name"
        :counter="30"
        :error-messages="nameErrors"
        @input="$v.name.$touch()"
        @blur="$v.name.$touch()"
        :disabled="isBusy"
        required
      ></v-text-field>
    </v-flex>
    <v-flex xs1>
      <v-progress-circular v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <v-icon v-if="success"
        large
        color="green darken-2"
      >
        done
      </v-icon>
      <v-icon v-if="fail"
              large
              color="red darken-2"
      >
        close
      </v-icon>
    </v-flex>
    <v-snackbar :timeout="3000" v-model="snackBar" bottom right>
      {{ snackBarText }}
      <v-btn flat color="pink" @click="snackClose">Close</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { snackbar } from '../../mixins/snackbar'
import { required, maxLength, numeric, minValue, maxValue } from 'vuelidate/lib/validators'
import { CODES_ADD } from '../../store/actions/codes'
export default {
  mixins: [validationMixin, snackbar],
  validations: {
    name: { required, maxLength: maxLength(30) },
    count: { required, numeric, minValue: minValue(1), maxValue: maxValue(20000) }
  },
  props: ['sku', 'distributor', 'order'],
  data: () => ({
    name: null,
    countRaw: '0',
    loading: false,
    success: false,
    fail: false,
    isZeroSku: false
  }),
  methods: {
    updateName: async function () {
      this.name = `${this.distributor.shortName}-${parseInt(this.order)}-${this.sku.code}-${this.sku.count}ab-${this.count}`
    },
    save: async function () {
      this.name = this.name.trim()
      this.$v.$touch()
      if (this.$v.$error || !this.count || this.isBusy) {
        this.$v.$reset()
        return
      }
      this.loading = true
      const newItem = await this.$store.dispatch(CODES_ADD, {
        name: this.name,
        distributorId: this.distributor.id,
        skuId: this.sku.id,
        blocksCount: this.sku.count,
        count: this.count,
        order: parseInt(this.order)
      })
      if (!newItem) {
        this.snack('name the same')
        this.success = false
        this.fail = true
      } else {
        this.success = true
        this.fail = false
      }
      this.loading = false
      this.$v.$reset()
    },
    close () {
      this.countRaw = '0'
      this.$v.$reset()
      this.loading = false
      this.success = false
      this.fail = false
    }
  },
  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.maxLength && errors.push('Name must be at most 30 characters long')
      !this.$v.name.required && errors.push('Name is required')
      return errors
    },
    countErrors () {
      const errors = []
      if (!this.$v.count.$dirty) return errors
      !this.$v.count.required && errors.push('Count is required')
      !this.$v.count.numeric && errors.push('Count must be numeric')
      !this.$v.count.minValue && errors.push('Count min value 1')
      !this.$v.count.maxValue && errors.push('Count max value 20000')
      return errors
    },
    isBusy () {
      return this.loading || this.success || this.fail
    },
    count () {
      return parseInt(this.countRaw)
    }
  },
  watch: {
    distributor: async function () {
      this.updateName()
    },
    sku: async function () {
      this.isZeroSku = !parseInt(this.sku.count)
      this.updateName()
    },
    order: async function () {
      this.updateName()
    },
    count: async function () {
      this.updateName()
    }
  },
  mounted: async function () {
    this.isZeroSku = !parseInt(this.sku.count)
    this.$root.$on('generate', this.save)
    this.$root.$on('close', this.close)
    this.updateName()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Codes/SkuGenerate.vue